export default "__VITE_ASSET__DjfsjgWC__"